import { Table } from "@organisms"
import TableView from "@organisms/ObjectsView/TableView/TableView"

import { BillingIntentions } from "@constants/choices"

export default function ClientTableView() {
    function getBillsTo(client: Client) {
        const intention = client.default_billing_intention

        if (intention === BillingIntentions.SERVICE_LOCATION) {
            return null
        } else if (intention === BillingIntentions.SERVICE_CLIENT) {
            return "This Client"
        } else if (intention === BillingIntentions.DIFFERENT_CLIENT) {
            return client.default_billing_client_name
        }

        return null
    }

    return (
        <TableView.Table>
            <Table.Column<Client>
                accessorKey="name"
                header="Client"
                size={224}
                cell={({ getValue }) => <Table.Cells.TextCell content={getValue()} />}
                enableSorting={true}
                enablePinning={true}
                dataType="alphabetical"
            />
            <Table.Column<Client>
                accessorKey="client_type_label"
                header="Type"
                size={112}
                cell={({ getValue }) => <Table.Cells.TextCell content={getValue()} />}
                enableSorting={true}
                enablePinning={true}
                dataType="other"
            />
            <Table.Column<Client>
                accessorKey="service_locations_display"
                header="Location"
                size={288}
                cell={({ getValue }) => <Table.Cells.TextCell content={getValue()} />}
                enableSorting={false}
                enablePinning={false}
                dataType="alphabetical"
            />
            <Table.Column<Client>
                accessorKey="bills_to"
                header="Bills To"
                size={224}
                cell={({ row }) => <Table.Cells.TextCell content={getBillsTo(row.original)} />}
                enableSorting={true}
                enablePinning={false}
                dataType="alphabetical"
            />
            <Table.Column<Client>
                accessorKey="default_invoice_net"
                header="Terms"
                size={144}
                cell={({ getValue }) => <Table.Cells.PaymentTermsCell terms={getValue()} />}
                enableSorting={true}
                enablePinning={false}
                dataType="numerical"
            />
            <Table.Column<Client>
                accessorKey="credit_limit"
                header="Credit Limit"
                size={144}
                cell={({ getValue }) => <Table.Cells.NumericalDataCell value={getValue()} type="currency" />}
                enableSorting={true}
                enablePinning={false}
                dataType="numerical"
                alignment="right"
            />
            <Table.Column<Client>
                accessorKey="labels"
                header="Labels"
                size={240}
                cell={({ getValue }) => (
                    <Table.Cells.BadgesCell
                        badges={(getValue() as ClientLabel[])?.map((label: ClientLabel) => label.name)}
                    />
                )}
                enableSorting={false}
                enablePinning={false}
                dataType="other"
                loadingType="badge"
            />
            <Table.Column<Client>
                accessorKey="last_modified_at"
                header="Last Modified"
                size={144}
                cell={({ getValue }) => <Table.Cells.DateTimeCell value={getValue()} />}
                enableSorting={true}
                enablePinning={false}
                dataType="timing"
            />
        </TableView.Table>
    )
}
